const handleSuccess = (response: any) => {
  return response;
};

export default handleSuccess;
